import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgBulletList = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M2.15 4.85a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7M6.2 2.6a.899.899 0 1 0 0 1.8h8.1a.899.899 0 1 0 0-1.8zm0 4.5a.899.899 0 1 0 0 1.8h8.1a.899.899 0 1 0 0-1.8zm0 4.5a.899.899 0 1 0 0 1.8h8.1a.899.899 0 1 0 0-1.8zm-4.05 2.25a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7M3.5 8A1.35 1.35 0 1 0 .8 8a1.35 1.35 0 0 0 2.7 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBulletList);
export default ForwardRef;
